module.exports = __webpack_public_path__ + "img/placeholder-1080.f2b95837.jpg";